import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'layout',
            component: () => import('@/components/layout.vue'),
            redirect: '/Home',
            children: [
                {
                    path: '/Home',
                    name: 'Home',
                    component: Home
                },
                {
                    path: '/About',//详情
                    name: 'About',
                    component: () => import('@/components/About.vue'),
                },
                {
                    path: '/homeland',//详情
                    name: 'homeland',
                    component: () => import('@/components/homeland.vue'),
                },
                {
                    path: '/dlete',//详情
                    name: 'dlete',
                    component: () => import('@/components/dlete.vue'),
                },
                {
                    path: '/dlete2',//详情
                    name: 'dlete2',
                    component: () => import('@/components/dlete2.vue'),
                },
                {
                    path: '/release',//发布
                    name: 'release',
                    component: () => import('@/components/release.vue'),
                },
                {
                    path: '/register',//注册
                    name: 'register',
                    component: () => import('@/components/register.vue'),
                },
                {
                    path: '/logion',//登录
                    name: 'logion',
                    component: () => import('@/components/logion.vue'),
                },
            ]
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js